  <mat-card>
      <mat-card-header>
          <mat-card-title>Lavorazione</mat-card-title>
      </mat-card-header>
      <mat-card-content class="content">

        <form [formGroup]="registerForm" (ngSubmit)="save()">

          <!--
                 <mat-form-field [style.display]="getConfigurazione().Nometipolavorazione" appearance="fill" style="padding-right: 10px">
                   <mat-label class="text-sm">Tipo lavorazione</mat-label>
                   <mat-select formControlName="selectedValueTipolavorazione" name="tipolavorazione" class="text-sm">
                     <mat-option></mat-option>
                     <mat-option *ngFor="let tipolavorazione of tipilavorazione" [value]="tipolavorazione.Nome" required>
                       {{tipolavorazione.Nome}}
                     </mat-option>
                   </mat-select>
                 </mat-form-field>
-->

          <mat-form-field [style.display]="getConfigurazione().Stato" appearance="fill" style="padding-right: 10px">
            <mat-label class="text-sm">Stato</mat-label>
            <mat-select formControlName="selectedValueStato" name="stato" class="text-sm" (selectionChange)="manageChangeStato()">
              <mat-option></mat-option>
              <mat-option *ngFor="let stato of stati" [value]="stato.Nome" required>
                {{stato.Nome}}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field [style.display]="getConfigurazione().Codice" class="example-full-width">
                    <mat-label class="text-sm">Codice</mat-label>
                    <input matInput placeholder="Codice" formControlName="Codice" name="Codice" >
          </mat-form-field>


          <mat-form-field [style.display]="getConfigurazione().Nome" class="example-full-width">
                    <mat-label class="text-sm">Nome</mat-label>
                    <input matInput placeholder="Nome" formControlName="Nome" name="Nome" required>
          </mat-form-field>

          <mat-form-field [style.display]="getConfigurazione().Codicecommessa" class="example-full-width">
                    <mat-label class="text-sm">Codicecommessa</mat-label>
                    <input matInput placeholder="Codicecommessa" formControlName="Codicecommessa" name="Codicecommessa" >
          </mat-form-field>

          <mat-form-field [style.display]="getConfigurazione().Codicestatolavorazione" class="example-full-width">
                    <mat-label class="text-sm">Codicestatolavorazione</mat-label>
                    <input matInput placeholder="Codicestatolavorazione" formControlName="Codicestatolavorazione" name="Codicestatolavorazione" >
          </mat-form-field>


        </form>
      </mat-card-content>
      <mat-card-actions>
        <table>
          <tr>
            <td>
              <button mat-raised-button  color="primary" (click)="save()">Salva</button>
            </td>
            <td>
              <button mat-raised-button  color="primary" (click)="cancel()">Cancella</button>
            </td>
          </tr>
        </table>
      </mat-card-actions>

  </mat-card>
